import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge, told about the type sizes this theme adds.
 *
 * It knows Tailwind's own `text-xs`…`text-6xl` as sizes, but reads any other
 * `text-*` as a colour. So `cn('text-chapter', 'text-ink')` looked to it like
 * two colours, and it dropped `text-chapter` as the loser — the size, the
 * weight and the leading all vanished without a warning. Every `--text-*`
 * step declared in `semantic.css` beyond Tailwind's defaults belongs here.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        '2xs',
        'md',
        'ghost',
        'chapter',
        'poster',
        'heading-xl',
        'heading-lg',
        'heading-md',
        'body-lg',
        'body',
        'body-sm',
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
